"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const _Vector = class _Vector {
  constructor(x, y) {
    __publicField(this, "x");
    __publicField(this, "y");
    if (typeof x !== "number") {
      throw new TypeError("x coordinate must be a Number");
    }
    if (typeof y !== "number") {
      throw new TypeError("y coordinate must be a Number");
    }
    this.x = x;
    this.y = y;
  }
  subtract(vec) {
    return new _Vector(this.x - vec.x, this.y - vec.y);
  }
  multiply(scalar) {
    return new _Vector(scalar * this.x, scalar * this.y);
  }
  // Rounds each coordinate to the nearest multiple of snapTo.
  snap(snapTo) {
    const snap = (val) => Math.round(val / snapTo) * snapTo;
    return new _Vector(snap(this.x), snap(this.y));
  }
  equals(vec) {
    return this.x === vec.x && this.y === vec.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  // The vector of length 1 in the same direction.
  normalize() {
    const length = this.length();
    if (length === 0) {
      throw new TypeError("Vector has length 0. Cannot normalize().");
    }
    return this.multiply(1 / length);
  }
};
// An arrow function, so call sites can pass it unbound, as in
// `points.map(Vector.fromObject)`.
__publicField(_Vector, "fromObject", (obj) => new _Vector(obj.x, obj.y));
let Vector = _Vector;
export {
  Vector as default
};
